<template>
  <div class="scan-login-container">
    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="扫描二维码"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />
    <div class="content">
      <img src="https://files.wondercv.com/rn/camera/pclogin.png" alt="" class="img-tip">
      <span class="message">电脑端登录确认</span>
      <span class="message-tips">信息将会同步到 APP</span>
      <div class="submit-btn" @click="login">登录</div>
      <span class="cancel-login" @click="leftBtnClick">取消登录</span>
    </div>
  </div>
</template>

<script>
import { envMixin } from '@/assets/js/mixin/global'
import { componentsMixin } from '@/assets/js/mixin/components'
import WNavbar from "@/components/global/w-navbar";
import Cookies from 'js-cookie'
import { userMixin } from '@/assets/js/mixin/user'
export default {
  // 扫码登录确认
  name: "scanLogin",
  mixins: [envMixin, componentsMixin, userMixin],
  components: {
    WNavbar
  },
  created() {

  },
  methods: {
    // 确认登录
    login() {
      let _t = Cookies.get('_t')
      let uuid = this.$route.query.uuid
      this.qrCodeToLogin({uuid: uuid, jwt: _t})
    },
    // 微信扫码成功之后调取登录接口
    async qrCodeToLogin(data) {
      try {
        let res = await this.$api.auth.scanQRCodeToLogin(data)
        if (res.code === 1000) {
          /***
           * timeout: 1 => 正常  2 => 超时
           * status: 1 => 正常  2 => jwt错误
           * ***/
          if (res.data && res.data.timeout === 2) {
            this.showToast('二维码失效，请刷新页面重试',1500)
          } else if (res.data && res.data.status === 1) {
            this.showToast('扫码成功，请等待跳转',1500)
            setTimeout(() => {
              this.leftBtnClick()
            }, 1500)
          }
        }else {
          this.showToast('扫码失败，请重试',1500)
        }
      } catch (e) {
        console.error(e,"扫码登录出错")
      }
    },
    // 返回个人中心页
    leftBtnClick() {
      this.$router.replace('/account/users/index')
    }
  }
}
</script>

<style lang="scss" scoped>
.scan-login-container {
  width: 100vw;
  height: 100vh;
  .content {
    width: 100%;
    height: 100%;
    //background-color: #00feff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .img-tip {
      width: 90px;
      height: 79px;
    }
    .message {
      margin-top: 24px;
      font-size: 16px;
      font-weight: 500;
      color: #606060;
      line-height: 16px;
    }
    .message-tips {
      margin-top: 12px;
      font-size: 14px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 14px;
    }
    .submit-btn {
      margin-top: 36px;
      width: 180px;
      height: 46px;
      background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      border-radius: 23px;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      line-height: 46px;
      text-align: center;
    }
    .cancel-login {
      margin-top: 36px;
      font-size: 14px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 14px;
    }
  }
}
</style>